import styled from 'styled-components/macro';
import BasicButton from 'components/button';
import { colors } from 'constants/styles/colors';
import { fontFamilyBase } from 'constants/styles/fonts';

// 30% of the lilac, as in the Figma tab pill.
const PILL_BACKGROUND = `${colors.dataVisualization.purple.light}4D`;

export const Container = styled.div`
  align-items: center;
  background: ${PILL_BACKGROUND};
  border-radius: 18px;
  display: flex;
  padding: 5px;
  width: 296px;
  margin-bottom: 23px;
`;

export const Button = styled(BasicButton)<{ $isActive: boolean }>`
  &&& {
    border-radius: 13px;
    border-width: 0px;
    flex: 1;
    height: 44px;
    width: 143px;
    box-shadow: none !important;
    background-color: ${({ $isActive }) =>
      $isActive ? colors.fonts.white : 'transparent'} !important;
    &:hover > div {
      opacity: 1;
    }
  }
`;

export const Option = styled.div<{ toggled: boolean }>`
  color: ${({ toggled }) =>
    toggled ? colors.palette.Business_DarkThemeGeneralBackground : colors.fonts.white};
  font-family: ${fontFamilyBase};
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
  opacity: ${({ toggled }) => (toggled ? 1 : 0.8)};
`;
